import { getVisibilityForGiftSet } from '@esentai/core/features/giftSets/selectors';
import withAsyncRunner from '@esentai/core/hocs/withAsyncRunner';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import { toggleVisibility } from '@/features/giftSetsPage/actions';

import VisibilityButton from './component';

const mapStateToProps = (state, { itemId }) => ({
  visible: getVisibilityForGiftSet(state, itemId),
});

const mapDispatchToProps = (dispatch, { itemId }) => ({
  onClick: () => dispatch(toggleVisibility(itemId)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withAsyncRunner({ runnerMethod: 'onClick' }),
)(VisibilityButton);
